// A page that cannot be shown displays an error page in its place: the address stays, so reloading tries again.
export type PageErrorStatus = 404 | 500

type State = {
  status: PageErrorStatus | null
}

const state: State = {
  status: null
}

const getters = {
  getStatus: (state:State) => {
    return state.status
  },
}

const mutations = {
  SET_STATUS: (state:State, status:PageErrorStatus | null) => {
    state.status = status
  },
}

const actions = {
  show: (context:any, status:PageErrorStatus) => {
    context.commit('SET_STATUS', status)
  },
  // The request a page needs failed. What the person cannot reach is not found, and the API wrapper already sends
  // a signed-out person to sign in.
  showForFailedRequest: (context:any, err?:{ response?: { status?: number } }) => {
    const status = err?.response?.status
    if (status === 401) {
      return
    }
    context.commit('SET_STATUS', status === 403 || status === 404 ? 404 : 500)
  },
  clear: (context:any) => {
    context.commit('SET_STATUS', null)
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
